if (window.BaseModal && !customElements.get('cancel-order-modal')) {
  customElements.define('cancel-order-modal', class CancelOrderModal extends window.BaseModal {})
}

if (!customElements.get('cancel-order-form')) {
  customElements.define(
    'cancel-order-form',
    class CancelOrderForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form')
        this.modal = this.querySelector('cancel-order-modal')
        this.summary = this.querySelector('[data-cancel-order-summary]')
        this.template = this.summary?.querySelector('template')
        this.opener = this.querySelector('[data-cancel-order-open]')
        this.confirm = this.querySelector('[data-cancel-order-confirm]')
        this.fields = this.querySelector('[data-cancel-order-fields]')

        this.discardForeignState()

        const success = this.querySelector('[data-cancel-order-success]')
        if (success) {
          this.restorePosition(success)
          return
        }

        const error = this.querySelector('[data-cancel-order-error]')
        if (error) this.restorePosition()

        if (!this.form || !this.modal || !this.opener || !this.template) return

        this.opener.setAttribute('type', 'button')
        this.opener.addEventListener('click', () => this.review())

        this.form.addEventListener('submit', (event) => {
          event.preventDefault()
          this.review()
        })

        this.querySelector('[data-cancel-order-back]')?.addEventListener('click', () => this.modal.close())
        this.confirm?.addEventListener('click', () => this.submit())
      }

      discardForeignState() {
        if (sessionStorage.getItem('contact-form') !== 'contact') return

        this.querySelector('[data-cancel-order-success]')?.remove()
        this.querySelector('[data-cancel-order-error]')?.remove()
        this.fields?.removeAttribute('hidden')
      }

      restorePosition(focusTarget) {
        const restore = () => {
          if (window.lenis) {
            window.lenis.resize()
            window.lenis.scrollTo(this, { immediate: true, force: true })
          } else {
            this.scrollIntoView({ block: 'start' })
          }

          focusTarget?.focus({ preventScroll: true })
        }

        if (document.readyState === 'complete') requestAnimationFrame(restore)
        else window.addEventListener('load', () => requestAnimationFrame(restore), { once: true })
      }

      review() {
        if (!this.form.reportValidity()) return

        this.renderSummary()
        this.modal.open(this.opener)
      }

      submit() {
        this.setPending(true)
        sessionStorage.setItem('contact-form', 'cancellation')
        this.form.submit()
      }

      setPending(pending) {
        if (!this.confirm) return

        this.confirm.toggleAttribute('disabled', pending)
        this.confirm.classList.toggle('opacity-60', pending)
        this.confirm.classList.toggle('pointer-events-none', pending)
      }

      renderSummary() {
        const fields = this.form.querySelectorAll('input:not([type="hidden"]), textarea')

        this.summary.querySelectorAll('[data-cancel-order-row]').forEach((row) => row.remove())

        fields.forEach(({ placeholder, value }) => {
          if (!placeholder || !value.trim()) return

          const row = this.template.content.firstElementChild.cloneNode(true)
          row.querySelector('dt').textContent = placeholder
          row.querySelector('dd').textContent = value.trim()

          this.summary.append(row)
        })
      }
    },
  )
}
